module.exports = __webpack_public_path__ + "static/media/welcomeBack.17ad0ad6.png";